import { TThunkAction } from 'shared/types/redux';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { selectSearchMetaData } from 'shared/selectors/searchMeta';
import { selectLocation } from 'shared/selectors/location';
import { updateLastAppliedFilter } from 'shared/slices/searchMetaTooltip';
import { dispatchFiltersUpdatedEvent } from 'shared/utils/event';

export const applyFilters = (): TThunkAction => (dispatch, getState) => {
  const state = getState();

  const jsonQuery = selectJsonQuery(state);
  const searchMeta = selectSearchMetaData(state);
  const location = selectLocation(state);

  dispatchFiltersUpdatedEvent({ jsonQuery, searchMeta, location });

  dispatch(updateLastAppliedFilter(null));
};
